module.exports = __webpack_public_path__ + "img/StoreShoes.c1a00ba7.png";